import { configureStore } from "@reduxjs/toolkit";
import useReducer from "./authRedux";
import dataReducer from "./alldata"
import { combineReducers } from "@reduxjs/toolkit";
import editableReducer from "./Editable";
import highlightIndex from './menuHighlight'
import YFHSreducer from './YFHSdataArray'
import FPreducer from './FPdataArray'

import {
    persistStore,
    persistReducer,
    FLUSH,
    REHYDRATE,
    PAUSE,
    PERSIST,
    PURGE,
    REGISTER,
  } from 'redux-persist';

import storage from 'redux-persist/lib/storage';

const persistConfig = {
    key:"root",
    version:1,
    storage:storage
}

const combined_reducers = combineReducers({
        user: useReducer,
        alldata:dataReducer,
        editable:editableReducer,
        highlight:highlightIndex,
        yfhsarray:YFHSreducer,
        fparray:FPreducer
})

const persistedReducer = persistReducer(persistConfig,combined_reducers);

export const store =  configureStore({
    reducer: persistedReducer,
    middleware:(getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck:{
            ignoreActions: [FLUSH,REHYDRATE,PAUSE,PERSIST,PURGE,REGISTER]
        }
    })
})

export const persistor = persistStore(store)